<template>
  <div class="">
    This is sms index route
    <router-view class="border-t border-grey-300" />
  </div>

</template>

<script>
// @ is an alias to /src

export default {
    name: 'sms.index',
    components: {

    }
};
</script>
